var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-scroll-board',{staticClass:"widget-view",attrs:{"config":_vm.viewProps.dataConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }